/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { RotateCcw } from 'lucide-react';
import ConfirmDialog from '../../components/ConfirmDialog';

function ArchiveModal({ title, description, policyName, setShowModal, callback, buttonName, tone, icon }) {
  return (
    <ConfirmDialog
      tone={tone}
      icon={icon || <RotateCcw size={24} />}
      title={title}
      description={description}
      confirmLabel={buttonName}
      cancelLabel="Cancel"
      onConfirm={() => callback()}
      onCancel={() => setShowModal(false)}
    >
      <p className="text-sm text-ink-500">
        Policy:
        {' '}
        <span className="font-semibold text-ink-900">{policyName}</span>
      </p>
    </ConfirmDialog>
  );
}

ArchiveModal.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  policyName: PropTypes.string.isRequired,
  setShowModal: PropTypes.func.isRequired,
  callback: PropTypes.func.isRequired,
  buttonName: PropTypes.string.isRequired,
  tone: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  icon: PropTypes.node,
};

ArchiveModal.defaultProps = { tone: 'success', icon: null };

export default ArchiveModal;
